import React from "react";
import "./landing_page.scss";

import FlipCard from "../../components/Flip_Card/Flip_Card";
import BottomBar from "../../components/Bottom_Bar/Bottom_Bar";

import IconWsp from "../../components/icon-wsp/Icon_Wsp";
import OctoCat from "../../components/octocat_icon/Octocat_Icon";
import IconLinkedin from "../../components/icon_linkedin/Icon_Linkedin";
import IconTelegram from "../../components/icon_telegram/Icon_Telegram";

import useObserver from "../../utilities/UseObserver";

const Landing_Page = () => {
  const [isIntersecting, refElement] = useObserver({
    rootMargin: "0px",
    root: null,
    threshold: 0.2,
  });

  return (
    <div className="presentation-container" ref={refElement} id={"inicio"}>
      <FlipCard />
      <BottomBar />
      <div
        className={
          isIntersecting
            ? "presentation-container__icono-wsp"
            : "presentation-container__icono-wsp--right"
        }
      >
        <IconWsp isIntersecting={isIntersecting} />
      </div>
      <div
        className={
          isIntersecting
            ? "presentation-container__icono-linkedin"
            : "presentation-container__icono-linkedin--right"
        }
      >
        <IconLinkedin isIntersecting={isIntersecting} />
      </div>
      <div
        className={
          isIntersecting
            ? "presentation-container__icono-github"
            : "presentation-container__icono-github--right"
        }
      >
        <OctoCat isIntersecting={isIntersecting} />
      </div>
      <div
        className={
          isIntersecting
            ? "presentation-container__icono-telegram"
            : "presentation-container__icono-telegram--right"
        }
      >
        <IconTelegram isIntersecting={isIntersecting} />
      </div>
    </div>
  );
};

export default Landing_Page;
